// extracted by mini-css-extract-plugin
export default {"page-loader":"PageLoader_page-loader__B0vhH","breathe":"PageLoader_breathe__CRHiG"};